import React from 'react'
import { connect } from 'react-redux'

import { Redirect } from 'react-router-dom'
import { userActions } from '../_actions'
import ReCAPTCHA from 'react-google-recaptcha'
import UnionSelect from '../_components/Shared/UnionSelect'

// import 'bootstrap/dist/css/bootstrap.min.css'
// import '../assets/css/bootstrap-rtl.css'
import '../assets/css/login.css'

class MembersLoginPage extends React.Component {
  constructor(props) {
    super(props)

    // reset login status
    this.props.dispatch(userActions.logout())

    this.state = {
      mobile: '',
      nationalCode: '',
      unionId: '',
      // captcha: false,
      submitted: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(e) {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  handleSubmit(e) {
    e.preventDefault()

    this.setState({ submitted: true })
    // const { mobile, nationalCode, unionId, captcha } = this.state;
    const { mobile, nationalCode, unionId } = this.state
    const { dispatch } = this.props
    // if (mobile && nationalCode && unionId && captcha) {
    //   dispatch(userActions.loginMembers(mobile, nationalCode, unionId));
    // }
    if (mobile && nationalCode && unionId) {
      dispatch(userActions.loginMembers(mobile, nationalCode, unionId))
    }
  }

  render() {
    const { loggingIn, loggedIn } = this.props
    // const { mobile, nationalCode, unionId, captcha, submitted } = this.state
    const { mobile, nationalCode, unionId, submitted } = this.state

    // this is where we get the old route - from the state of the redirect
    const { from } = this.props.location.state || {
      from: { pathname: '/member' }
    }
    if (loggedIn) {
      return <Redirect to={from} />
    }

    return (
      <div className="container-fluid login-body">
        <div className="login text-center">
          <div className="row flex-row">
            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="left-panel">
                <img src="/home/logo.png" alt="" />

                <form name="form" onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="form-inline">
                      <div className="col-md-12 text-right">
                        <label className="pull-right">تلفن همراه</label>
                        <input
                          type="text"
                          className="text-input"
                          autoComplete="off"
                          name="mobile"
                          defaultValue={mobile}
                          placeholder="تلفن همراه ﺧﻮد را وارد ﻧﻤﺎﯾﯿﺪ"
                          disabled={loggingIn}
                          onChange={this.handleChange}
                        />
                        {submitted && !mobile && (
                          <div
                            className={'required_validator visible'}
                            style={{ left: 'auto' }}>
                            <div
                              className="validator_container"
                              style={{ paddingRight: 20, paddingLeft: 20 }}>
                              <span>تلفن همراه وارد نشده است</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="clearfix" />

                      <div className="col-md-12 text-right">
                        <label className="pull-right">کد ملی</label>
                        <input
                          type="nationalCode"
                          className="text-input"
                          autoComplete="off"
                          name="nationalCode"
                          defaultValue={nationalCode}
                          placeholder="کد ملی خود را وارد نمایید"
                          disabled={loggingIn}
                          onChange={this.handleChange}
                        />
                        {submitted && !nationalCode && (
                          <div
                            className={'required_validator visible'}
                            style={{ left: 'auto' }}>
                            <div
                              className="validator_container"
                              style={{ paddingRight: 20, paddingLeft: 20 }}>
                              <span>کد ملی وارد نشده است</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="clearfix" />

                      <div className="col-md-12 text-right">
                        <label className="text-right">نام اتحادیه</label>
                        <UnionSelect
                          sympleStyle={true}
                          disabled={loggingIn}
                          required
                          defaultValue={this.state.unionId}
                          onChange={val => {
                            this.setState({ unionId: val })
                          }}
                        />
                        {submitted && !unionId && (
                          <div
                            className={'required_validator visible'}
                            style={{ left: 'auto' }}>
                            <div
                              className="validator_container"
                              style={{ paddingRight: 20, paddingLeft: 20 }}>
                              <span>اتحادیه انتخاب نشده است</span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="clearfix" />

                      {/* <div className="col-md-12 text-right">
                        <label className="pull-right">عبارت امنیتی</label>
                        <ReCAPTCHA
                          name="captcha"
                          // sitekey="6LdAR7IUAAAAAPPz8y3B9OKFenQV81XiVAOBixgx"
                          sitekey="6LeV3swUAAAAAFYTtvUdqNord4LHGMQdumehzkl1"
                          onChange={() => this.setState({ captcha: true })}
                        />
                        {submitted && !captcha &&
                          <div className={"required_validator visible"} style={{ left: 'auto' }}><div className="validator_container" style={{ paddingRight: 20, paddingLeft: 20 }}><span>لطفا عبارت امنیتی را تایید نمائید</span></div></div>}
                      </div> */}

                      <div className="clearfix" />
                      <br />

                      <div className="col-md-12">
                        <button>
                          {loggingIn && (
                            <i className="mdi mdi-spin mdi-loading" />
                          )}
                          &nbsp; ورود به سامانه &nbsp;
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="right-panel">
                <div className="header">
                  <h1>ﺳﺎﻣﺎﻧﻪ آﻣﻮزش اﺻﻨﺎف</h1>
                  <p>
                    ﻫﻤﮑﺎران ﮔﺮاﻣﯽ ﻟﻄﻔﺎ در ﺣﻔﻆ و ﻧﮕﻬﺪاری ﺣﺴﺎب ﮐﺎرﺑﺮی ﺧﻮد دﻗﺖ
                    ﻓﺮﻣﺎﯾﯿﺪ
                    <br />
                    ﻣﺴﺌﻮﻟﯿﺖ ﻧﮕﻬﺪاری از ﻣﺸﺨﺼﺎت ﮐﺎرﺑﺮی ﺑﺮﻋﻬﺪه اﺗﺤﺎدﯾﻪ ﻣﯽ ﺑﺎﺷﺪ
                  </p>
                </div>

                <img src="/login/ex-img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { loggingIn, loggedIn } = state.authentication
  return {
    loggingIn,
    loggedIn
  }
}

const connectedLoginPage = connect(mapStateToProps)(MembersLoginPage)
export { connectedLoginPage as MembersLoginPage }
